import { render, staticRenderFns } from "./AdmissionsList.vue?vue&type=template&id=48e64d80&scoped=true&"
import script from "./AdmissionsList.vue?vue&type=script&lang=js&"
export * from "./AdmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e64d80",
  null
  
)

export default component.exports